import {put, takeLatest, call} from 'redux-saga/effects';
import * as promotionService from "../../../../services/promotionService.js";
import {
    ADD_PROMOTION,
    ADD_PROMOTION_SUCCESS,
    ADD_PROMOTION_ERROR
}
    from "../../../actions/menu/promotions";

function* addPromotionSaga(action) {
    try {
        const data =  yield call(promotionService.AddPromotion, action.payload)
        yield put({
            type: ADD_PROMOTION_SUCCESS,
            payload: data
        });

    } catch (error) {
        yield put({
            type: ADD_PROMOTION_ERROR,error: error.data
        });
    }
}


export function* addPromotionSagaWatcher() {
    yield takeLatest(ADD_PROMOTION, addPromotionSaga);
}